import {
  faEdit,
  faKeyboard,
  faImageLandscape,
  faObjectsAlignTop,
  faObjectsAlignBottom,
  faSquareList,
} from "@fortawesome/pro-light-svg-icons";
export const OBJECTS: any[] = [
  {
    name: "Text",
    type: { type: "object", details: "textBox" },
    icon: faKeyboard,
    enabled: true,
  },
  {
    name: "Image",
    type: { type: "object", details: "image" },
    icon: faImageLandscape,
    enabled: false,
  },

  {
    name: "Header",
    type: { type: "object", details: "header" },
    icon: faObjectsAlignTop,
    enabled: false,
  },
  {
    name: "Footer",
    type: { type: "object", details: "footer" },
    icon: faObjectsAlignBottom,
    enabled: false,
  },
];
